import ColorSwatch from '~/components/ColorSwatch';
import { FIELD_SIZING } from '~/theme/fieldSizing';

/** A structure's display colour, at the swatch size the form fields share. */
export default function StructureSwatch({
    color,
    className,
}: {
    color: string;
    className?: string;
}) {
    return (
        <ColorSwatch
            background={color}
            width={FIELD_SIZING.swatch}
            height={FIELD_SIZING.swatch}
            className={className}
        />
    );
}
